import type { Card, Chassis, Rarity } from "../types";
import { isDriver } from "../types";
import type { AttrLabel } from "./i18n";
import { t } from "./i18n";

export const esc = (s: string): string =>
  s.replace(/[&<>"']/g, (ch) =>
    ch === "&"
      ? "&amp;"
      : ch === "<"
        ? "&lt;"
        : ch === ">"
          ? "&gt;"
          : ch === '"'
            ? "&quot;"
            : "&#39;",
  );

export const rarBadge = (r: Rarity): string => `<span class="crar ${r}">${esc(t().rarity(r))}</span>`;

/** The chassis model without its redundant team prefix, e.g. "McLaren MP4/4
 *  1988" → "MP4/4 1988". Used wherever the team name is already shown alongside. */
export const chassisModel = (c: Chassis): string => c.model.replace(c.team + " ", "");

/** Today as a YYYY-MM-DD key in UTC. The daily seed and "played today" use this,
 * so the challenge is the same worldwide on a given calendar day (rolls at 00:00 UTC). */
export function todayKey(now: Date = new Date()): string {
  const y = now.getUTCFullYear();
  const m = String(now.getUTCMonth() + 1).padStart(2, "0");
  const d = String(now.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function cardTitle(c: Card): string {
  return isDriver(c)
    ? `${esc(c.name)} <span style="color:var(--muted);font-weight:400">${esc(c.team)}</span>`
    : `${esc(c.team)} <span style="color:var(--muted);font-weight:400">${esc(chassisModel(c))}</span>`;
}

export function cardMeta(c: Card): string {
  return isDriver(c) ? `${c.country}` : esc(t().chassisMeta);
}

export function cardStats(c: Card, hidden = false): string {
  const v = (n: number): string => (hidden ? "?" : String(n));
  const A = t().attrs;
  // Abbreviation shown, full attribute name on hover.
  const cell = (a: AttrLabel, n: number): string =>
    `<span title="${esc(a.full)}">${a.abbr} <b>${v(n)}</b></span>`;
  return isDriver(c)
    ? `${cell(A.pace, c.pace)}${cell(A.consistency, c.consistency)}${cell(A.rain, c.rain)}`
    : `${cell(A.motor, c.motor)}${cell(A.aero, c.aero)}`;
}
